import React from "react";
import "../style/fordentist.css";
import { ToothZapFooter } from "../layouts/footer";
import { Nav } from "../layouts/header";

export default function ForDentist() {
  return (
    <div className="fd-wrapper">
          <Nav />
      <div className="container tz-container">
        <section className="fd-fordentistse">
          <div className="fd-hero-left pt-3">
            <p className="fd-tag">
              JOIN TOOTHZAP — SAME-DAY CROWN DELIVERY FOR DELHI DENTISTS
            </p>

            <h1>
            Turn scan uploads into fitted crowns before the day’s chair schedule breaks.
            </h1>

            <p className="fd-desc">
              ToothZap gives Delhi dentists faster turnaround, fewer second
              visits, and clearer case tracking through a verified same-day
              crown network.
            </p>

            <div className="fd-buttons py-2">
              <button className="primary-btn-join-us">Join Us</button>
              <button className="secondary-btn-book">Book a Demo</button>
            </div>
          </div>

   
          <div className="fd-card-section">
            <div className="table-section-dentist">
                <div className="chaiside-live">
           <div className="logo-wrapper-part">
  

  <div className="icon-circle-sect">
    <i className="bi bi-lightning-fill"></i>
  </div>


  <div className="logo-text">
    <div className="toothzap">ToothZap</div>
    <div className="dashboard-text">DENTIST DASHBOARD</div>
  </div>

           </div>
           <div className="chair-sidediv">
            Chairside Live

           </div>
              
              </div>
                
                
                
               
            </div>
           

            <div className="stats padding-20px">
              <div>
                <h3>06</h3>
                <p>Active Cases</p>
              </div>
              <div>
                <h3>03</h3>
                <p>Ready to Fit</p>
              </div>
              <div>
                <h3>02</h3>
                <p>Awaiting Approval</p>
              </div>
              <div>
                <h3>14</h3>
                <p>Avg ETA (min)</p>
              </div>
            </div>
            <div className="table-wrapper">
<div className="table-maindiv">
            <table  className="padding-30px table-sectionhere">
                <thead>
                    <tr>
                        <th>Case ID</th>
                        <th>Patient</th>
                        <th>Stage</th>
                        <th>ETA</th>
                    </tr>
                </thead>
              <tbody>
                <tr>
                  <td>TZ1842</td>
                  <td>R. Malhotra</td>
                  <td>CAD in progress</td>
                  <td>14 min</td>
                </tr>
                <tr>
                  <td>TZ1843</td>
                  <td>A. Kohli</td>
                  <td>Milling complete</td>
                  <td className="green">Ready</td>
                </tr>
                <tr>
                  <td>TZ1844</td>
                  <td>P. Arora</td>
                  <td>With rider</td>
                  <td>9 min</td>
                </tr>
                <tr>
                  <td>TZ1845</td>
                  <td>S. Bedi</td>
                  <td>Awaiting approval</td>
                  <td className="red">Action needed</td>
                </tr>
              </tbody>
            </table>
            </div>
            </div>
          </div>
        </section>
        <section className="fd-section row">
            <div className="col-md-8">
                <p className="section-label-benefits">PAIN POINTS</p>
          <h2>
            The operational friction is predictable, and it keeps same-day crown
            delivery out of reach for most clinics.
          </h2>
          </div>

          <div className="fd-grid-3">
            <div className="fd-card">
              <h4>Lab delays</h4>
              <p className="lab-delay">
              Traditional turnaround slows down restorative treatment and forces clinics to wait on external production timelines.
              </p>
            </div>

            <div className="fd-card">
              <h4>Multiple visits</h4>
                <p className="lab-delay">
              Patients return for fitment because crown manufacturing happens too far downstream from the appointment.
              </p>
            </div>

            <div className="fd-card">
              <h4>No case tracking</h4>
               <p className="lab-delay">
               Teams lose visibility after scan upload, making it harder to coordinate design, milling, dispatch, and patient expectations.
              </p>
            </div>
          </div>
        </section>

        <section className="fd-section row pt-5">
              <div className="col-md-7">
                <p className="section-label-benefits">Solution</p>
          <h2>
            ToothZap is built to remove the exact bottlenecks that make same-day
            crowns unreliable.
          </h2>
          </div>

          <div className="fd-grid-2">
            <div className="fd-card">
              <h5 className="problem">PROBLEM</h5>
              <p className="dentist-lose">Dentists lose momentum after the scan is captured.</p>
              <h5>SOLUTION</h5>
              <p className="solution-text">
               ToothZap routes the case into in-house CAD and partner production immediately so the workflow keeps moving.
              </p>
            </div>

            <div className="fd-card">
              <h5 className="problem">PROBLEM</h5>
              <p className="dentist-lose">Chair schedules are disrupted by uncertain turnaround times.</p>
              <h5>SOLUTION</h5>
              <p className="solution-text">The network compresses production into a same-visit window with defined milestones your front desk can communicate.</p>
            </div>

            <div className="fd-card">
              <h5>PROBLEM</h5>
              <p className="dentist-lose">There is no simple way to coordinate local milling capacity.</p>
              <h5>SOLUTION</h5>
              <p className="solution-text">
               Verified Delhi production partners handle manufacturing while clinics stay focused on treatment and fitment.
              </p>
            </div>
          </div>
        </section>
</div>
  
        {/* DARK STRIP */}
        <div className="fd-dark container-fluid">
        <div className="container tz-container">
            <div className="row">
                <div className="col-md-12">
   <div className="how-thetoothzap" >                
   How the ToothZap dental crown workflow  <br/>works </div> 
                </div>
            </div>
      
       
        </div></div>
 <div className="container tz-container">
     <div className="row">
         <div className="col-md-8">
                <p className="section-label">Benefits</p>
           <h2 className="what-delhi-dentist">What Delhi dentists gain by joining the <br/> network</h2>
          </div>
          </div>
        <section className="fd-section">
       

         <div className="fd-grid-3">
  {[
    {
      title: "Faster restorative completion",
      desc: "Close eligible crown cases in a single visit instead of splitting treatment across multiple appointments."
    },
    {
      title: "No in-house mill required",
      desc: "Offer same-day capability without taking on machine cost, maintenance, or idle hardware risk."
    },
    {
      title: "Live workflow visibility",
      desc: "Track the case from scan upload through design, production, and local dispatch with clearer expectations."
    },
    {
      title: "Verified network support",
      desc: "Use vetted local milling partners instead of managing a fragmented vendor chain on your own."
    },
    {
      title: "Stronger patient experience",
      desc: "Reduce second-visit drop-off by keeping treatment momentum inside the same chairside session."
    },
    {
      title: "Scalable clinic operations",
      desc: "Add same-day crown capacity across busy days without expanding your clinical team or floor footprint."
    }
  ].map((item, i) => (
    <div className="fd-card" key={i}>
      <span className="fd-number">0{i + 1}</span>
      <h4>{item.title}</h4>
      <p className="card-description">{item.desc}</p>
    </div>
  ))}
</div>
        </section>

       <section className="fd-section">
  <div className="row">
    
    {/* LEFT SIDE */}
    <div className="col-md-5">
      <p className="section-label-benefits">Dashboard Preview</p>

      <h2 className="what-delhi-dentist-gain">
        See active same-day cases, production stage, and <br/>  handoff timing in one view.
      </h2>

      <p className="card-description2">
       The live dashboard helps clinics understand what is happening after upload without calling the lab, chasing dispatch updates, or  guessing delivery timing.
      </p>

      <button className="primary-btn-join-us mt-4">Book Demo to See More</button>
    </div>

    {/* RIGHT SIDE */}
    <div className="col-md-7">
      <div className="fd-dark-card">
        <div className="todays-active">
   <div className="today-active">
    <div className="clinic-queue">Clinic Queue</div>
      <h4>Today's active crown cases</h4>
   </div>
   <div className="btn-section">
    <button className="primary-btn-join-us">3 Live</button>
   </div>
        </div>
      
      <div className="r-malhotra-section">
        <div className="malhotra-detail">
            <div className="t-z-184">TZ-1842</div>
 <div className="case">R. Malhotra - 14 min</div>
 <div className="cad-in">CAD in progress</div>
        </div>
        <div className="14-min">
            <div className="ETA">ETA</div>
            <div className="min-14">14 min</div>
        </div>

      </div>
           <div className="r-malhotra-section">
        <div className="malhotra-detail">
            <div className="t-z-184">TZ-1843</div>
 <div className="case"> A. Kohli</div>
 <div className="cad-in">Milling complete</div>



        </div>
        <div className="14-min">
            <div className="ETA">ETA</div>
            <div className="min-14">Dispatching</div>
        </div>

      </div>
          <div className="r-malhotra-section">
        <div className="malhotra-detail">
            <div className="t-z-184">TZ-1844</div>
 <div className="case"> P. Arora</div>
 <div className="cad-in">With rider</div>
        </div>
     
        <div className="14-min">
            <div className="ETA">ETA</div>
            <div className="min-14">9 min</div>
        </div>

      </div>
        
      </div>
    </div>

  </div>
</section>
   </div>
    <section className="fd-blue container-fluid">
        <div className="container tz-container">
            <div className="row">
                <div className="col-md-12">
                    <p className="testimonials">Dentist Testimonials</p>
  Why dentists join ToothZap
                </div>
            </div></div>
      
       
        </section>

        <section className="fd-cta">
               <h2 className="what-delhi-dentist py-5 mb-5">Dentist onboarding and workflow questions</h2>
          <h2  className="what-delhi-dentist mt-2">Ready to join the Delhi same-day crown network?</h2>
          <p className="mt-2">Onboarding takes under 20 minutes.</p>
           <button className="primary-btn-join-us mt-1">Join Us</button>
        </section>
   
        <ToothZapFooter />
    </div>
   
  );
}